import { ICountryConfig } from '@root/query'
import { useValidatedValue } from './useValidatedValue'
import dayjs from 'dayjs'
import { useMemo } from 'react'
import { getVatOptions } from '@root/utils/getVatOptions'

export const useVatOptions = (countryConfig: ICountryConfig | null | undefined, value: string) => {
  const validDate = useValidatedValue<string, dayjs.Dayjs>({
    value,
    formatter: dateStr => dayjs(dateStr, 'YYYY-MM-DD'),
    validator: dateStr => dayjs(dateStr, 'YYYY-MM-DD').isValid()
  })

  return useMemo(
    () =>
      getVatOptions(countryConfig, validDate).map(options => ({
        value: options.rate,
        label: `${options.rate} %`
      })),
    [validDate?.toISOString(), countryConfig]
  )
}
